import { withInstall } from '@ll-plus/utils'

import Badge from './src/badge.vue'

export const LlBadge = withInstall(Badge)
export default LlBadge
export * from './src/badge'

declare module 'vue' {
  export interface GlobalComponents {
    LlBadge: typeof Badge
  }
}
